import { getLocaleByIndex, getLocaleByI18nKey } from "../lng/Locales";
import { emitToServer } from "../index";

import { set } from "dot-prop-immutable";

/* state = {
 *   "-1": -> plant
 *   "0": -> Kompressor 1
 *   "1": -> Kompressor 2
 *   "2": {
 *     "1": -> Fehlerbit 1 gesetzt
 *     "10": -> Fehlerbit 10 gesetzt
 *     "100": {
 *       "de": "Das ist Fehler 100"
 *       "en": "This is error 100"
 *     }
 *   }
 * }
 * Kein Array, weil dieses recht schnell sparse wird, und Javascript
 * dann sehr wahrscheinlich sowieso die gleiche Implementierung wie
 * für Object verwenden wird.
 */

const FEHLERTEXT_EMPFANGEN = "FEHLERTEXT_EMPFANGEN";
const FEHLERTEXT_RESET = "FEHLERTEXT_RESET";

export const fehlertextReceivedAction = fehlertext => ({
	type: FEHLERTEXT_EMPFANGEN, fehlertext
});

export const fehlertextResetAction = () => ({
	type: FEHLERTEXT_RESET
});

const initial_state = {};

export const fehlertextReducer = (state = initial_state, action) => {
	switch (action.type) {
	case FEHLERTEXT_EMPFANGEN: {
		let pos = "" + action.fehlertext.component;
		let c = state[pos];
		if (!c) {
			return set(state, pos, {
				[action.fehlertext.msg_index]: {
					[getLocaleByIndex(action.fehlertext.language).i18n_key]: 
						action.fehlertext.msg
				}
			});
		}
		pos += "." + action.fehlertext.msg_index;
		let e = c[action.fehlertext.msg_index];
		if (!e) {
			return set(state, pos, {
				[getLocaleByIndex(action.fehlertext.language).i18n_key]:
					action.fehlertext.msg
			});
		}
		let lkey = getLocaleByIndex(action.fehlertext.language).i18n_key;
		pos += "." + lkey;
		return set(state, pos, action.fehlertext.msg);
	}
	case FEHLERTEXT_RESET:
		return initial_state;
	default:
		return state;
	}
};

const addLeadingZeros = (number, places) => {
	places -= number.length;
	while (places > 0) {
		number = "0" + number;
		--places;
	}
	return number;
};

const fallbackFehlertext = (component, bit_index) => {
	let number = null;
	let text = null;
	/* Die folgende Abgrenzung zwischen Wartungen ("M"), Warnungen ("W") und Fehlern ("E"),
	 * sowie die Wandlung bit_index zu einer Fehlernummer hängt auch mit der
	 * Implementierung in der HE/P zusammen! Das ist leider so.
	 * siehe ACHESTD plckerror.h für KMNROFFSET, KWNROFFSET und KENROFFSET
	 * KENROFFSET wird lustigerweise dazugezählt, die anderen beiden abgezogen ...
	 * Hier immer noch 1 für die 1-basierte Anzeige dazuzählen.
	 * Leider sind die Grenzen für Wartungen/Warnungen/Fehler für GLW und Kompressor unterschiedlich!
	 */
	const KMNROFFSET = 0;
	const KWNROFFSET = 4;
	const KENROFFSET = -20;
	const KM_NUM_REGISTERS = 1;
	const KW_NUM_REGISTERS = 4;
	const KE_NUM_REGISTERS = 15;
	// siehe ACHESTD plcgerror.h
	const GMNROFFSET = 0;
	const GWNROFFSET = 4;
	const GENROFFSET = -4;
	const GM_NUM_REGISTERS = 1;
	const GW_NUM_REGISTERS = 3;
	const GE_NUM_REGISTERS = 4;
	const num_and_offsets = [
		/* Station */
		{
			maint: { num: GM_NUM_REGISTERS, offset: GMNROFFSET },
			warn:  { num: GW_NUM_REGISTERS, offset: GWNROFFSET },
			error: { num: GE_NUM_REGISTERS, offset: GENROFFSET }
		},
		/* Kompressoren */
		{
			maint: { num: KM_NUM_REGISTERS, offset: KMNROFFSET },
			warn:  { num: KW_NUM_REGISTERS, offset: KWNROFFSET },
			error: { num: KE_NUM_REGISTERS, offset: KENROFFSET }
		}
	];
	const num_and_offset = num_and_offsets[component === -1 ? 0 : 1];
	if (bit_index < num_and_offset.maint.num * 16) {
		number = (bit_index + num_and_offset.maint.offset + 1).toString();
		text = "M" + addLeadingZeros(number, 3);
	} else if (bit_index < (num_and_offset.maint.num + num_and_offset.warn.num) * 16) {
		number = (bit_index + num_and_offset.warn.offset + 1).toString();
		text = "W" + addLeadingZeros(number, 3);
	} else if (bit_index < (num_and_offset.maint.num + num_and_offset.warn.num + num_and_offset.error.num) * 16) {
		number = (bit_index + num_and_offset.error.offset + 1).toString();
		text = "E" + addLeadingZeros(number, 3);
	}
	return text;
};

export const getFehlertext = (cindex, eindex, fehlertexte, locale) => {
	let obj = fehlertexte[cindex.toString()];
	if (obj) {
		obj = obj[eindex.toString()];
		if (obj) {
			let text = obj[locale];
			if (text) {
				return text;
			}
		}
	}
	emitToServer("fehlertext", {
		component: cindex,
		language: getLocaleByI18nKey(locale).index_in_ablauf,
		msg_index: eindex
	});
	return fallbackFehlertext(cindex, eindex);
};
